<template>
  <div class="content email-verification">
    <div class="container">
      <header-logo :logo-url="globalLogoUrl" />
      <h1 v-word:layout.EmailVerification.header />

      <section v-show="(loaded && tokenIsValid) || showAll"
               class="form__section">
        <div class="">
          <h2 v-word:layout.EmailVerification.valid.text />
          <div>
            <div class="form__message form__section__links form__section__links__center">
              <br><br>
              <a :href="!editMode && $router.resolve({ name: 'user-profile' }).href"
                 v-word:layout.EmailVerification.link.toUserProfile />
            </div>
          </div>
        </div>
      </section>
      <section v-show="(loaded && !tokenIsValid) || showAll"
               class="form__section">
        <h2 v-word:layout.EmailVerification.invalid.text />
      </section>
      <section v-show="!loaded || showAll"
               class="form__section">
        <div class="form__message"
             v-word:layout.EmailVerification.loading.text />
      </section>

    </div>
  </div>
</template>

<script>
import * as mixins from '../mixins';
import config from 'config';
import instanceConfig from '../utils/instanceConfig';
import backendConfig from '../utils/backendConfig';
import urlUtil from '../utils/url';

export default {
  props: ['store', 'showAll', 'editMode'],
  mixins: [mixins.wordedPage, mixins.pageWithLogo],
  data() {
    return {
      tokenIsValid: true,
      loaded: false,
      token: urlUtil.parseQueryParam('token'),
      returnUrl: '',
    };
  },
  mounted() {
    !this.editMode &&
      this.verifyToken()
        .then(() => {
          this.tokenIsValid = true;
          this.loaded = true;
        })
        .catch(() => {
          this.tokenIsValid = true;
          this.loaded = true;
        });
    // Edge has some problem with finally
    // .finally(() => {
    //   this.loaded = true;
    // });
  },
  created() {
    !this.editMode &&
      instanceConfig
        .get()
        .then(config => {
          this.returnUrl = config['return-url'];
        })
        .catch(() => {});
  },
  methods: {
    backToPortal() {
      if (this.returnUrl) {
        window.location = this.returnUrl;
      }
    },
    verifyToken() {
      return backendConfig.get().then(({backendUrl}) => {
        const url =
          backendUrl + config.backend.feeds.verifyEmailVerificationToken +
          '?sso=' +
          this.store.brokerData;

        this.$emit('loading');
        return this.$http
          .post(url, { token: this.token })
          .then(() => {
            this.$emit('loaded');
          })
          .catch(() => {
            this.$emit('loaded');
          });
        // Edge has some problems with finally
        // .finally(() => {
        //   this.$emit('loaded');
        // });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/EmailVerification.vue